export const fortunesIt = [
  `L'amore non è trovare una persona perfetta, è vedere perfettamente una persona imperfetta.`,
  `Una bugia facile può essere più utile di una verità complicata.`,
  `Se tutto quello che hai è un martello, ogni cosa ti sembrerà un chiodo.`,
  `L'unico modo per avere un vero amico è diventarlo.`,
  `La felicità è il risultato della decisione di essere felici.`,
  `Meglio un uovo oggi che una gallina domani.`,
  `Non esistono scorciatoie per posti in cui vale la pena andare.`,
  `Se sei disposto ad ammettere i tuoi difetti, hai un difetto in meno da ammettere.`,
  `Il modo migliore per eliminare la tentazione è soccombere ad essa.`,
  `Chi è presuntuoso non arriva mai da nessuna parte, perché pensa di essere già arrivato.`,
  `Chi dice che qualcosa è impossibile, non dovrebbe mai interrompere chi ce la sta facendo.`,
  `Le abitudini sono come una corda: se si aggiunge un filo al giorno, diventerà impossibile da spezzare.`,
  `Quando la tua luce è più forte, non stare nell'ombra.`,
  `Chi più dà più riceve.`,
  `Non si può raggiungere la cima della montagna senza prima scalare.`,
  `Le idee sono strane: funzionano solo se si mettono in atto.`,
  `Se continuerai a fare quello che già stai facendo, i risultati saranno sempre gli stessi.`,
  `Quando concentri i tuoi sforzi, fa’ sì che il tempo sia il tuo miglior alleato.`,
  `Ci sono momenti in cui l'unica soluzione è prendersi una pausa.`,
  `Ogni cosa può fornire insegnamenti, se si è disposti ad imparare.`,
  `Un giorno sei il piccione, un altro la statua.`,
  `Un leader vede più in altre persone che in se stesso.`,
  `Non puoi mungere una mucca che non hai.`,
  `Chiunque abbia detto "vincere non è importante" probabilmente aveva già perso.`,
  `Le cattive abitudini sono come gli ospiti – facili da accogliere, difficili da mandare via.`,
  `E' facile essere coraggiosi da una certa distanza di sicurezza.`,
  `La conoscenza è riconoscere che la strada è a senso unico, ma la saggezza è guardare comunque in entrambe le direzioni.`,
  `Se vedi una tartaruga sulla staccionata, sicuramente ha avuto qualche aiuto per arrivarci.`,
  `Ama i tuoi nemici, li farai assolutamente impazzire.`,
  `Ogni quercia ha iniziato da una noce che ha saputo stare al proprio posto.`,
  `Il cambiamento è un bene... ma i soldi sono anche meglio.`,
  `Le aquile possono levarsi in volo, ma almeno le donnole non vengono risucchiate dai motori.`,
  `L'unico sostituto delle cattive maniere sono i buoni riflessi.`,
  `Potremmo tutti imparare una lezione dal tempo. Non presta attenzione alle critiche.`,
  `Prima rimani indietro, più tempo avrai per recuperare.`,
  `Non rammaricarti: la metà delle persone che conosci sono sotto la media.`,
  `Se pensi che una debolezza possa essere trasformata in un punto di forza, hai un'altra debolezza.`,
  `Siamo più bravi a mantenere le promesse agli altri che a noi stessi.`,
  `Non scappare dalle tue paure - quando ti raggiungeranno, sarai ormai troppo stanco per combattere.`,
  `Ad ogni alba sorge una nuova possibilità, che si spreca nuovamente ad ogni tramonto.`,
  `Ricorda che il dolore è il modo in cui la natura ti ricorda chi comanda.`,
  `Se non sopporti il caldo, non stuzzicare il drago.`,
  `Non sai mai di cosa puoi fare a meno finché non te ne privi. `,
  `Pesce grande mangia pesce piccolo. `,
  `Un cane in una cuccia abbaia alle sue pulci. Un cane a caccia non le nota nemmeno.`,
  `La vita è come un rotolo di carta igienica. Più ti avvicini alla fine, più velocemente scorre.`,
  `La gente sembra avere nostalgia di un sacco di cose di cui non andava matta la prima volta.`,
  `Quando sei in dubbio, fermati a pensare.`,
  `Chiunque abbia detto "non importa vincere o perdere" probabilmente è perché ha perso.`,
  `Potresti non avere tutto quello che serve per finire, ma probabilmente hai già quello che serve per iniziare.`,
  `La maggior parte delle persone sono come le vesciche - non si fanno vedere fino a quando il lavoro non è finito.`,
  `La cosa più facile è essere se stessi.`,
  `Meglio un giorno da leone che cento da pecora.`,
  `Fai attenzione quando manipoli la verità - alla fine ti si ritorcerà contro.`,
  `Il sintomo della noia indica un potenziale inutilizzato`,
  `Non rimandare a domani qualcosa che sai già di poter evitare fin da adesso. `,
  `Non serve a nulla dare consigli. Il saggio non ne avrà bisogno, mentre lo stupido non ascolterà.`,
  `Non accontentarti di qualcosa di semplice ed efficiente quando puoi renderlo complesso e meraviglioso.`,
  `Meglio fallire provandoci che non provarci affatto.`,
  `Non serve a niente essere preparati ad ogni emergenza se si è impreparati alla vita quotidiana.`,
  `Non si è mai troppo vecchi per fare qualche scemenza. `,
  `Aver bisogno di qualcuno è come aver bisogno di un paracadute. Se non c'è la prima volta che ne hai bisogno, è probabile che non ti servirà più. `,
  `Il tempo vola come una freccia scoccata da un arco.`,
  `Le persone peggiori da cui ricevere consigli sono quelle che di solito danno consigli.`,
  `Se non fosse per l'ultimo minuto, non si sarebbe mai fatto nulla.`,
  `Non bussare alla porta della morte, ma suona il campanello e scappa. La morte odia quando si fa così.`,
  `A nessuno piacciono i sapientoni... specialmente quando sono più di uno.`,
  `Chi dorme non prende pesci. `,
  `Il miglior posto in cui poter trovare una mano è alla fine del tuo braccio.`,
  `Due regole di vita: fai attenzione al numero uno e cerca di non calpestare il numero due.`,
  `Punta alla luna. Se la manchi, almeno finirai tra le stelle.`,
  `La discrezione è l'arte di dire ciò che si pensa e di togliersi di mezzo prima che qualcuno capisca.`,
  `La gente non resiste al cambiamento, ma resiste a subire dei cambiamenti.`,
  `Si è giovani solo una volta, ma si può essere immaturi per tutta la vita.`,
  `Una curva non rappresenta la fine di una strada - a meno che tu non riesca a svoltare.`,
  `Oggi è il giorno delle decisioni definitive! ... oppure no?`,
  `Chi dice che non devi preoccuparti delle piccole cose, non ha mai provato a dormire nella stessa stanza con una zanzara.`,
  `I forti sottraggono ai deboli, ma gli intelligenti sottraggono ai forti.`,
  `Ci sono sempre due motivi per fare qualcosa: uno è un buon motivo e l’altro è il vero motivo.`,
  `Assicurati che la luce in fondo al tunnel… non siano i fari di un treno che sta per investirti.`,
  `Più un uomo invecchia, più si capisce quanto da ragazzo ha dovuto camminare per andare a scuola.`,
  `Le uniche persone con cui dovresti cercare di pareggiare i conti sono quelle che ti hanno aiutato.`,
  `Chiunque può ammettere a se stesso di aver sbagliato, ma solo il saggio lo ammetterà anche di fronte agli altri.`,
  `Le menti piccole sono le prime a condannare le grandi idee.`,
  `Resistere alla tentazione è più facile quando pensi che probabilmente avrai un'altra possibilità.`,
  `Uno non si fa dei nuovi amici, ma li riconosce come tali.`,
  `Ama tutti, fidati di pochi e rema sempre sulla tua barca. `,
  `Vivi ogni giorno come se fosse l'ultimo della tua vita, anche perché finora lo è.`,
  `La risata è il farmaco del buonumore senza effetti collaterali.`,
  `A furia di provare ad essere come qualcun altro, butti via il tempo per essere la persona che sei.`,
  `Di solito è più facile puntare il dito anziché offrire una mano in segno d’aiuto.`,
  `Se non hai il tempo di farlo bene la prima volta, devi avere il tempo di riprovare.`,
  `L'amore è il trionfo dell'immaginazione sull'intelligenza.`,
  `I soldi non fanno la felicità, ma è meglio piangere su una Porsche che su una bicicletta.`,
  `Se la gente parla male di te, fai in modo che nessuno gli creda.`,
  `Il lavoro duro paga nel lungo periodo. La pigrizia paga ora.`,
  `L'esperienza è la peggior insegnante. Ti dà sempre prima il test e solo dopo le istruzioni.`,
  `Se non riesci ad imparare a fare bene qualcosa, impara almeno a divertirti facendola male.`,
  `La nostalgia è rendersi conto che le cose non andavano così male come pensavamo.`,
  `La vita è come una lotteria. Devi metterti in gioco se vuoi vincere.`,
  `Ama il tuo vicino ma non togliere la siepe.`,
  `Non avere mai paura di tentare qualcosa di nuovo. Ricorda: dei dilettanti costruirono l'arca mentre il Titanic fu costruito da professionisti. `,
  `Alcune persone hanno una grande cerchia di amici, mentre altre hanno solo amici con cui si trovano bene.`,
  `Dopo che si è detto e fatto tutto, rimane sempre più da fare che da dire.`,
  `Troppe persone si offrono di spostare lo sgabello anche quando è ormai il momento di muovere il pianoforte.`,
  `Se non stai vivendo al limite, stai occupando troppo spazio.`,
  `Tutte le generalizzazioni sono false - inclusa questa.`,
  `La fortuna è solo una scusa usata dai perdenti per giustificare la posizione di un vincente.`,
  `Anche se cadi a faccia in giù, ti stai comunque muovendo in avanti.`,
  `Il tempo è un grande maestro, ma alla fine uccide tutti i suoi allievi.`,
  `Chi semina vento raccoglie tempesta.`,
  `Colui che disse "le cose buone arrivano a chi sa aspettare" probabilmente sta ancora aspettando.`,
  `Dice il saggio: mai giocare alla cavallina con un unicorno. `,
  `Il buon giudizio viene dall'esperienza, e l'esperienza viene dal cattivo giudizio.`,
  `Prima di criticare qualcuno, cammina per un miglio nelle sue scarpe.`,
  `Solo Robinson Crusoe finiva tutto entro Venerdì, e grazie all’aiuto di quest’ultimo.`,
  `Non discutere mai con un idiota: la gente potrebbe non notare la differenza.`,
  `Avere il diritto di fare qualcosa non significa che sia giusto farlo.`,
  `Molta gente crede di pensare mentre sta solo riordinando i propri pregiudizi.`,
  `La brutta notizia è che il tempo vola, ma la buona notizia dice che almeno il pilota sei tu. `,
  `Non si può avere tutto. Voglio dire, dove lo metteresti?`,
  `Scegli gli amici per il loro carattere e i calzini per il loro colore.`,
  `Il denaro è come il letame che non serve se non è sparso.`,
  `Una lingua tagliente è l’unico strumento acuminato che migliora con l’uso.`,
  `Sii gentile con le persone scortesi - sono quelle che ne hanno più bisogno.`,
  `La felicità si raggiunge quando sì è troppo impegnati per poter essere infelici.`,
  `Invecchiare è obbligatorio, ma crescere è solo un’opzione.`,
  `È impossibile fare una qualsiasi cosa a prova d’idiota perché arriverà sempre uno ancor più idiota. `,
  `Non si apprezza mai quello che si ha finché non lo si perde.`,
  `Il piacere più grande nella vita è fare ciò che le persone dicono che non puoi fare.`,
  `Un errore è tale solo se ti rifiuti di correggerlo.`,
  `La ragione per cui i computer fanno più lavoro delle persone è che non s’interrompono mai per rispondere al telefono.`,
  `Anche il saggio ha bisogno di momenti di svago di tanto in tanto.`,
  `È sempre più facile risolvere i problemi altrui che i propri.`,
  `Per ogni problema complesso, c'è sempre una soluzione semplice. Che è sbagliata.`,
  `Molte persone parlano solo perché non sanno stare in silenzio.`,
  `L'avaro diventa ricco facendo mostra di essere povero, mentre il prodigo s'impoverisce facendo mostra di essere ricco.`,
  `I fulmini non cadono mai nello stesso posto.`,
  `Un uomo di parola ma non di fatti è come un giardino di erbacce senza fiori.`,
  `Maggiore l’ostacolo, maggiore la gloria nel superarlo.`,
  `Un consiglio è ciò che chiediamo quando già conosciamo la risposta ma vorremmo non conoscerla. `,
  `Le parole dovrebbero essere pesate, non contate.`,
  `Un mare calmo non ha mai fatto un buon marinaio.`,
  `Il secondo è solamente il primo dei perdenti.`,
  `Non possiamo dirigere il vento, ma possiamo orientare le vele.`,
  `"È forse colpa della sorgente se il corso del torrente si perde nel pantano?"`,
  `Se continui a fare quello che hai sempre fatto, continuerai ad ottenere ciò che hai sempre avuto.`,
  `Il silenzio è più potente di qualsiasi linguaggio, di qualsiasi nome, di qualsiasi parola.`,
  `Il diavolo ha molti strumenti da dare, ma la bugia è sicuramente quella che va per la maggiore.`,
  `Many people speak because (and only because) they don't know how to be silent.`,
  `Uno dei più grandi sbagli della vita è vivere con la paura di sbagliare.`,
  `La vita non consiste nell'avere buone carte, ma nel saper giocare bene quelle che si hanno.`,
  `Niente rende una persona più produttiva dell'ultimo minuto.`,
  `Le persone felici non hanno sempre il meglio, ma sfruttano al massimo quello che hanno.`,
  `Lezione fondamentale che ci insegna il tempo atmosferico: fregarsene delle critiche.`,
  `Se per colazione mangi un rospo ancora vivo, almeno puoi star certo che non ti succederà niente di peggio per il resto della giornata.`,
  `Se devi prendere in prestito dei soldi, chiedili a un pessimista - almeno non si aspetta di riaverli indietro.`,
  `Dio ha saggiamente progettato il corpo umano in modo da non poterci dare né una pacca sulle spalle né prenderci a calci troppo facilmente. `,
  `Anche un maiale cieco ogni tanto trova una ghianda.`,
  `E' meglio essere un nessuno che realizza qualcosa che un qualcuno che non realizza nulla.`,
  `Non vi è cuscino più morbido di una coscienza tranquilla.`,
  `Se ti manca il coraggio di iniziare, hai già perso.`,
  `Scegli il lavoro che ami e non lavorerai neppure un giorno in tutta la tua vita.`,
  `Se ascolti troppi consigli, potresti finire col fare gli errori degli altri. `,
  `Solo il cane da slitta in testa, vede il mondo ogni giorno in modo diverso.`,
  `Per raggiungere una grande altezza, serve innanzitutto una grande profondità.`,
  `Molte persone, quando si fermano a pensare, dimenticano che devono ricominciare.`,
  `Nessuno ti presta attenzione finché non commetti un errore.`,
  `Con le bugie si può andare - ma non si può mai tornare indietro.`,
  `Se fai centro ogni volta, significa che il bersaglio è troppo vicino. `,
  `L'uomo è l'unico animale che arrossisce. O che ne abbia bisogno.`,
  `Se guardi i tuoi problemi da vicino, potresti renderti conto di farne parte.`,
  `Cerca di dimenticare qualcosa di nuovo ogni giorno.`,
  `Anche provando a vivere un giorno alla volta, può succedere di ritrovarseli tutti insieme.`,
  `Se vuoi riuscirci, devi credere che sia possibile.`,
  `Usa parole dolci, nel caso tu debba poi rimangiartele.`,
  `Persone e ghepardi sono molto simili – non arrivano lontano senza correre rischi.`,
  ` Vivere immersi nel lusso è stupendo, finché non finiamo la bombola d’ossigeno.`,
  `Più lo farai e meglio continuerai a farlo.`,
  `È meglio avere un nemico debole che un amico forte.`,
  `È difficile lasciare il segno se si passa tutto il tempo seduti.`,
  `Chi va con lo zoppo, impara a zoppicare.`,
  `Dire scusa è un buon modo per avere l'ultima parola. `,
  `Ricorda sempre che sei unico esattamente come tutti gli altri.`,
  `Il successo è un viaggio, non un punto di arrivo.`,
  `Non è la felicità che ci rende grati, ma la gratitudine che ci rende felici.`,
  `Le parole che ti penetrano nelle orecchie sono quelle sussurrate, non urlate.`,
  `Una cascata non è altro che una moltitudine di gocce che vanno nella stessa direzione.`,
  `Una nave nel porto è sicura, ma non è ciò per cui è stata costruita.`,
  `Un pavone che si siede sulla sua coda è solo un altro tacchino.`,
  `Se il lupo non è alla tua porta, non cercarlo né invitalo ad entrare.`,
  `Il modo migliore per dimenticare tutti i problemi è quello di indossare scarpe strette.`,
  `Pensa a come essere spontaneo domani.`,
  `E' meglio rimanere in silenzio e lasciare che pensino che sei uno stupido, piuttosto che aprire la bocca e dimostrarlo,`,
  `Il denaro non è tutto, ma è molto più importante di qualsiasi cosa sia al secondo posto.`,
  `Un giorno senza sole è notte.`,
  `Prima cadrai, prima riprenderai a correre.`,
  `Un'intuizione è la tua creatività che cerca di dirti qualcosa.`,
  `Errare è umano e lo è anche dare la colpa a qualcun altro.`,
  `Il problema di fare bene qualcosa la prima volta è che nessuno capisce quanto sia stato difficile.`,
  `Solo chi non si aspetta nulla non rimane mai deluso.`,
  `Un biglietto ti farà salire sul treno, ma l'aglio ti farà avere un posto.`,
  `Chiedi perdono oggi! Domani potresti non sentirti così colpevole.`,
  `Non serve dar prova di intelligenza a chi ne è privo.`,
  `Se all'inizio non hai successo, nascondi il fatto di averci provato.`,
  `Non usare un parolone quando basterebbe un diminutivo.`,
  `L'esperienza è qualcosa che non si ottiene fino a quando non se ne ha bisogno.`,
  `Vivi ogni giorno come se fosse l'ultimo. Un giorno potresti avere ragione.`,
  `Il mondo è piccolo... ma non vorresti comunque dipingerlo.`,
  `Dorme bene chi ha la coscienza a posto.`,
  `La gente si preoccuperebbe meno di quello che gli altri pensano di loro se solo si rendessero conto di quanto raramente lo fanno.`,
  `Nulla migliora la tua memoria quanto cercare di dimenticare.`,
  `La differenza tra genio e stupidità è che il primo ha dei limiti.`,
  `Il successo è come una carriola. Non succede niente a meno che tu non cominci a spingere.`,
  `L'uccello mattiniero può prendere il verme, ma è il secondo topo che prende il formaggio.`,
  `Il corpo umano è stato creato in modo che non potessimo darci pacche sulla schiena né calci troppo facilmente.`,
  `Chi dice che qualcosa è impossibile, non dovrebbe interrompere chi ce la sta facendo.`,
  `Il filo d'erba più alto è il primo ad essere tagliato.`,
  `Un po' di sciocchezze ogni tanto sono apprezzate dagli uomini più saggi.`,
  `Quando sei in acque profonde, è una buona idea tenere la bocca chiusa.`,
  `Sii coerente, ma non sempre.`,
  `Il modo più veloce per raddoppiare i tuoi soldi è quello di piegarli a metà e rimetterli in tasca.`,
  `La differenza tra genio e stupidità è che il primo ha dei limiti.`,
  `Il modo migliore per trovare qualcosa che hai perso è sostituirla.`,
  `Le persone responsabili affrontano la musica, anche se odiano la melodia.`,
  `Una barca in mare calmo non va lontano.`,
  `Fai una domanda stupida e sembrerai stupido per cinque minuti. Non fare domande e sembrerai sciocco per sempre.`,
  `L'unica cultura che alcune persone hanno sta crescendo sugli avanzi nei loro frigoriferi.`,
  `Sei giovane solo una volta, ma con la pratica, puoi essere immaturo per tutta la vita.`,
  `Non pensare che non ci siano coccodrilli solo perché l'acqua è calma.`,
  `Troppe persone si offrono volontarie per portare uno sgabello quando è il momento di spostare un pianoforte.`,
  `A volte la luce alla fine del tunnel dice "Vietato uscire"`,
  `Una bocca chiusa non acchiappa zanzare.`,
  `Fidarsi è bene, non fidarsi è meglio.`,
  `La felicità non è ottenere tutto quello che vuoi, ma rendersi conto che ce l'hai già.`,
  `Due cose difficili da gestire con grazia: il fallimento e il successo.`,
  `Il valore delle persone è rivelato da come trattano coloro che non possono rendere un favore.`,
  `Una persona presuntuosa non arriva mai da nessuna parte, perché è sempre sicura di essere già arrivata.`,
  `Una buona relazione è come una casseruola. Solo coloro che la rendono possibile sanno esattamente cosa c'è all’interno.`,
  `Una coscienza pulita è segno di cattiva memoria.`,
  `Chi non trova le chiavi, trova conforto nel sapere che l’universo non è infinito.`,
  `Una cravatta pulita attrae la zuppa del giorno. `,
  `Un'autorità è una persona che può dirti di più su qualcosa di quanto a te interessi sapere.`,
  `Se sei arrabbiato per quello che non hai, sprecherai quello che hai.`,
  `La consapevolezza è quando sei a conoscenza di qualcosa. La coscienza è quando vorresti non esserlo.`,
  `Conta la tua età in base agli amici, non agli anni.`,
  `Quando gli elefanti combattono, solo l'erba si fa male.`,
  `Il vero amore è il trionfo dell'immaginazione sull'intelligenza.`,
  `Un pettegolezzo che non ha una gamba su cui stare troverà un altro modo per andare in giro.`,
  `Una persona è grande quanto le cose che la fanno arrabbiare.`,
  `La preoccupazione genera una grande ombra su una cosa molto piccola.`,
  `Sei quello che mangi.`,
  `La preoccupazione è come una sedia a dondolo. Si finisce per spendere un sacco di sforzo senza arrivare da nessuna parte.`,
  `Un computer può essere in grado di batterti a scacchi... ma probabilmente non a kickboxing.`,
  `Una riunione è un evento in cui si impiegano minuti e si sprecano ore.`,
  `C'è una grande differenza tra conoscenza e intelligenza.`,
  `Niente rende un pesce più grande che essere quasi catturato.`,
  `Meglio una misera scusa che nessuna.`,
  `Una buona bugia trova più seguaci di una cattiva verità.`,
  `E' meglio chiedere due volte che perdere la strada una volta.`,
  `Il modo più efficace per apparire saggi è quello di rimanere in silenzio.`,
  `Se arrivi alla fine della tua corda, fai un nodo e tieniti forte.`,
  `Una coscienza colpevole non ha bisogno di un accusatore.`,
  `Rendi la tua casa abbastanza pulita per essere sano e abbastanza disordinata per essere felice.`,
  `Nelle riunioni, pensa attentamente a quanto spesso intervieni. Assicurati di riservare il tuo tempo per i punti che pensi siano i più importanti.`,
  `La stalla logora un cavallo più della strada.`,
  `Alcune persone hanno tatto, altre dicono la verità.`,
  `L'invidia spara agli altri, ma colpisce se stessa.`,
  `Meglio poco che niente.`,
  `Se non ci fossero stupidi nel mondo, tutte le persone sarebbero d'accordo su tutto.`,
  `L'opportunità bussa sempre al momento meno opportuno.`,
  `La pazienza è l'arte di nascondere la tua impazienza.`,
  `La gente che dice "non sto giocando" sta già facendo il proprio gioco. `,
  `La canna più sottile si piegherà al vento, mentre la quercia più alta... fa un sacco di bei mobili.`,
  `Il segreto del successo è capire a chi dare la colpa dei tuoi fallimenti.`,
  `La fiducia si ottiene solo dopo molte azioni, ma può essere persa con una sola.`,
  `Chi troppo vuole, nulla stringe.`,
  `Mente aperta e bocca chiusa formano una combinazione felice.`,
  `La bellezza è negli occhi di chi guarda – o magari sono semplicemente delle cispe.`,
  `Non ti arrovellare per cose insignificanti. `,
  `L'efficienza non è altro che pigrizia intelligente.`,
  `Una briciola al tavolo del vincitore ha un sapore migliore di un banchetto al tavolo del perdente.`,
  `E se non ci fossero situazioni ipotetiche?`,
  `Quando i tuoi più grandi sogni diventano polvere, è il momento di spazzare.`,
  `Non sei chi pensi di essere, non sei chi pensano che tu sia, ma potresti essere chi pensi che loro pensino che tu sia.`,
  `L'obiettivo della scienza è creare migliori trappole per topi. L'obiettivo della natura è creare topi migliori.`,
  `Il peggior biscotto è pur sempre meglio del miglior cavoletto di Bruxelles.`,
  `Ci sono due tipi di persone al mondo: chi dà e chi prende. Chi prende mangia meglio, ma chi dà dorme meglio.`,
  `Non si piange sul latte versato.`,
  `Quando il tuo lavoro parla da solo, cerca di non interromperlo.`,
  `Un buono spavento è più utile di un buon consiglio.`,
  `Le persone che tengono per sé le loro opinioni raramente si sbagliano.`,
  `Non puoi scoprire nuovi oceani se non sei disposto a perdere di vista il molo.`,
  `Più sai, più ti sembra di non sapere.`,
  `I migliori piani di topi e uomini... di solito includono il formaggio.`,
  `Se non riesci a ridere di te stesso, forse ti stai perdendo la battuta del secolo.`,
  `Alcune persone sognano in grande, altre mettono in pratica quei sogni.`,
  `Un pessimista vede la difficoltà in ogni opportunità; un ottimista vede l'opportunità in ogni difficoltà.`,
  `La fede è un uccello che sente la luce e inizia a cantare mentre il cielo è ancora buio.`,
  `La generosità verrà ripagata prima di quanto immagini.`,
  `Gli sciocchi usano il domani. I saggi usano l'oggi.`
]
